import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import { DualRangeSliderStyles } from "./dualRangeSlider.styles";

const DualRangeSlider = ({
  min = 0,
  max = 200,
  step = 5,
  valueFrom,
  valueTo,
  nameFrom,
  nameTo,
  onChange,
  onBlur,
}) => {
  const fromVal = Number(valueFrom) || min;
  const toVal = Number(valueTo) || max;

  const handleChange = (values) => {
    const [newFrom, newTo] = values;
    if (newFrom !== fromVal) {
      onChange({ target: { name: nameFrom, value: String(newFrom) } });
    }
    if (newTo !== toVal) {
      onChange({ target: { name: nameTo, value: String(newTo) } });
    }
  };

  return (
    <DualRangeSliderStyles>
      <div className="sliderWrapper">
        <Slider
          range
          min={min}
          max={max}
          step={step}
          value={[fromVal, toVal]}
          onChange={handleChange}
          allowCross={false}
        />
      </div>
      <div className="valuesDisplay">
        <div className="valueBadge">
          <span className="badgeLabel">From</span>
          <span className="badgeAmount">${fromVal}</span>
        </div>
        <span className="valueDash">—</span>
        <div className="valueBadge">
          <span className="badgeLabel">To</span>
          <span className="badgeAmount">${toVal}</span>
        </div>
      </div>
      <div className="rangeLabels">
        <span>${min}</span>
        <span>${max}</span>
      </div>
    </DualRangeSliderStyles>
  );
};

export default DualRangeSlider;
